import {isDefined} from 'shared/utils/custom-utils';
import type {Validator} from 'svelte-forms';
import {notBlankValidator, patternValidator, requiredValidator} from '../../internal/validators';
import type {SanitizeHtmlFunction} from '../../../../svelte/types';
import type {HtmlValueEditorOptions} from './types';
import type {Formatter, Parser} from '../../internal/forms/types';
import type {HtmlValueEditorValidations} from './types';

export function validatorFactory(validations: HtmlValueEditorValidations) {
    const validators: Validator[] = [];

    if (isDefined(validations.required) && validations.required) {
        validators.push(requiredValidator());
    }

    if (isDefined(validations.notBlank) && validations.notBlank) {
        validators.push(notBlankValidator());
    }

    if (isDefined(validations.pattern)) {
        validators.push(patternValidator(new RegExp(validations.pattern)));
    }

    return validators;
}

export function sanitizeHtmlParser(sanitizeFunction: SanitizeHtmlFunction, options: HtmlValueEditorOptions): Parser {
    return (value: string) => {
        if (!!value && options.sanitizeInput) {
            return sanitizeFunction(value);
        }
        return value;
    }
}

export function sanitizeHtmlFormatter(sanitizeFunction: SanitizeHtmlFunction): Formatter {
    return (value: string) => {
        if (!!value) {
            return sanitizeFunction(value);
        }
        return value;
    }
}